import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgPlayFill = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M26.25 14a1.722 1.722 0 0 1-.831 1.478L9.66 25.118a1.75 1.75 0 0 1-2.421-.602A1.735 1.735 0 0 1 7 23.639V4.361a1.735 1.735 0 0 1 .888-1.512 1.75 1.75 0 0 1 1.772.033l15.759 9.64A1.723 1.723 0 0 1 26.25 14Z" />
  </svg>
);
export default SvgPlayFill;
